export const initialState = {
  openPanel: '',
  filters: {},
  metricTitle: null,
  metric: null,
};

export function performanceSlideouts(state = initialState, action) {
  switch (action.type) {
    case 'performanceSlideouts/OPEN': {
      const { metric, panel, filters, metricTitle } = action;
      return {
        ...state,
        filters,
        metricTitle,
        openPanel: panel,
        metric,
      };
    }
    case 'performanceSlideouts/CLOSE': {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
